export default {
	'beehive-system': 'Beehive system'
}